<file-pond #myPond [options]="pondOptions" (onaddfile)="pondHandleAddFile($event)"
    (onremovefile)="pondHandleRemoveFile($event)">
</file-pond>
<mat-error *ngIf="this.form.get(this.name)?.errors && (this.form.get(this.name)?.dirty || this.form.get(this.name)?.touched)">
    <b>{{ getError() }}</b>
</mat-error>
